import { format } from "d3-format";
import { useMemo } from "react";

const useFormat = (fmt: string) => {
  return useMemo(() => format(fmt), [fmt]);
};

export default useFormat;
